<app-rfi-answer-completeness [completeness]="completeness()" />
<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
  @for (group of groups(); track group.titleKey) {
    <app-rfi-assessment-group [group]="group" />
  }
</div>
<span class="text-muted-color text-sm">
  {{ 'project.steps.providerResults.individual.cultureHint' | transloco }}
</span>
